<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="divisionEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Division</h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="Algemeen">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Company</mat-label>
                                <input matInput name="CompanyName" [(ngModel)]="Copy.CompanyName" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Description</mat-label>
                                <textarea matInput name="Description" [(ngModel)]="Copy.Description"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                          <app-dropdown-option model="Document" discriminator="Currency" name="Currency"
                                               [(ngModel)]="Copy.Currency"
                                               placeholder="Currency"></app-dropdown-option>
                        </div>
                        <div class="col-md-6">
                            <app-locale-selector name="Locale" placeholder="Language"
                                                 [(ngModel)]="Copy.Locale"></app-locale-selector>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>VAT Number</mat-label>
                              <input [(ngModel)]="Copy.VATNumber" matInput name="VatNumber">
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Logo">
                    <div class="row">
                        <div class="col-12">
                            <mat-card appearance="outlined">
                              <mat-card-header>
                                <mat-card-title>Your logo</mat-card-title>
                                <mat-card-subtitle>This logo is shown on documents</mat-card-subtitle>
                                <button type="button" mat-icon-button (click)="test.click()">
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <button type="button" mat-icon-button (click)="Copy.Logo = null">
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </mat-card-header>
                                <mat-card-content>
                                    <img *ngIf="Copy.getLogoAsBase64(); else nologo"
                                         [src]="Copy.getLogoAsBase64() | safeHtml" style="max-height:200px;">
                                  <ng-template #nologo>You don't have a logo yet.</ng-template>
                                    <input type="file" name="file" (change)="readFile($event);" accept="image/*" #test
                                           style="display:none;">
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Beheerders">
                    <table class="mat-mdc-table" style="min-width: 400px">
                        <tr>
                          <th>Name</th>
                            <th style="text-align: right;">
                                <button type="button" mat-icon-button (click)="aEditor.edit({Division: Copy})">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </th>
                        </tr>
                        <tr *ngFor="let accountDivision of Copy.AccountDivisions">
                            <td>{{accountDivision.Account?.getFullName()}}</td>
                            <td style="text-align: right;">
                                <button type="button" mat-icon-button (click)="aEditor.edit(accountDivision)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button type="button" mat-icon-button appConfirmDialog
                                        (confirm)="aEditor.remove(accountDivision)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </table>
                </mat-tab>
                <mat-tab label="Uitgaande e-mails">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Mail name</mat-label>
                              <input [(ngModel)]="Copy.MailName" matInput name="MailName"
                                     required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Default reply email</mat-label>
                              <input type="email" matInput name="MailReplyto" [(ngModel)]="Copy.MailReplyto"
                                     email required>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [isLoading]="isLoading" [disabled]="!editorForm.form.valid"
                        nameAttr="btnSaveDivision"></app-button>
        </mat-dialog-actions>
    </form>

    <app-account-division-editor #aEditor [(List)]="Copy.AccountDivisions"></app-account-division-editor>
</ng-template>
